export enum IVehicleTypes {
    Flatbed = 0,
    Bulker = 1
}